<div class="dash-card-wrapper" [ngClass]="colorClass">
  <div class="dash-card">
    <ng-container *appHasPermission="viewPermission">
      <div
        *ngIf="link"
        class="arrow-icon"
        [routerLink]="link"
        style="cursor: pointer"
      >
        <img src="../../../assets/images/icons/white-arrow-icon.svg" alt="" />
      </div>
    </ng-container>
    <div class="head-wrapper">
      <ng-content select="[icon]"></ng-content>

      <h5 [ngClass]="textColorClass">{{ title }}</h5>
    </div>

    <h6 [ngClass]="textColorClass">{{ count || "0" }}</h6>
    <div class="add-btn btn-wrapper">
      <p class="dash-sub-one" *ngIf="subTitle || subCount !== undefined">
        {{ subTitle }}
        <span [ngClass]="textColorClass">{{ subCount || "0" }}</span>
      </p>

      <!-- <ng-container *appHasPermission="addPermission">
        <button class="dash-add" *ngIf="addLink" [routerLink]="addLink">
          add
          <span>
            <img src="../../../assets/images/icons/white-add-icon.svg" alt="" />
          </span>
        </button>
      </ng-container> -->
    </div>
  </div>
</div>
